<aayn-error-modal-content
  *ayn-loader="loader$ | async"
  [title]="title"
  [buttonTemplate]="buttonTemplate"
  [descriptionTemplate]="contentTemplate"
  [isStatic]="true"
>
</aayn-error-modal-content>

<ng-template #contentTemplate let-modal>
  <p class="mb-3">
    {{ text | translate }}
  </p>
  <ayn-table *ngIf="selectedPage && selectedInstagramAccount">
    <ng-template #body>
      <tr>
        <td class="align-content-center">{{ 'Selected Page ' | translate }}</td>
        <td>
          <div class="d-flex align-items-center">
            <img
              style="width: 30px; height: 30px; border-radius: 10px; margin-right: 10px"
              [src]="selectedPage.imageUrl"
              [alt]="selectedPage.name"
            />
            {{ selectedPage.name }}
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ 'Selected Instagram Account' | translate }}</td>
        <td>
          <b>{{ selectedInstagramAccount.name }}</b>
        </td>
      </tr>
    </ng-template>
  </ayn-table>
</ng-template>

<ng-template #buttonTemplate>
  <button
    *ngIf="cancelButtonText"
    type="button"
    ayn-button="primary"
    icon="chevron-left"
    icon-direction="left"
    (click)="cancel()"
    class="mr-2"
  >
    {{ cancelButtonText | translate }}
    <div *ngIf="!buttonText"></div>
  </button>
  <button
    *ngIf="buttonText"
    type="button"
    ayn-button="orange-gradient"
    icon="chevron-right"
    icon-direction="right"
    (click)="confirm()"
  >
    {{ buttonText | translate }}
  </button>
</ng-template>
